import { render } from "./AdminVouchers.vue?vue&type=template&id=652d7f58"
import script from "./AdminVouchers.vue?vue&type=script&lang=js"
export * from "./AdminVouchers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__